import { render, staticRenderFns } from "./session-details.page.vue?vue&type=template&id=024dd107&scoped=true&"
import script from "./session-details.page.vue?vue&type=script&lang=js&"
export * from "./session-details.page.vue?vue&type=script&lang=js&"
import style0 from "./session-details.page.vue?vue&type=style&index=0&id=024dd107&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "024dd107",
  null
  
)

export default component.exports